export default __webpack_public_path__ + "static/3-35f8e5693200149803c91ae1def522b3.png";